import { styled } from "@vitality-ds/system";
import BaseValueTextStyles from "./styles/BaseValueText.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseValueText = styled("span", BaseValueTextStyles);